import * as Yup from 'yup'

export const validationSchema = Yup.object().shape({
  content_types: Yup.array()
    .of(
      Yup.object().shape({
        code: Yup.string().defined(),
        text: Yup.string().defined(),
      })
    )
    .min(1, 'Please, select categories')
    .required('Content types are required'),
})
